"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionAuthorityTypes = void 0;
var SessionAuthorityTypes;
(function (SessionAuthorityTypes) {
    SessionAuthorityTypes["ANONYMOUS"] = "ANONYMOUS";
    SessionAuthorityTypes["FULL_AUTHENTICATED_USER"] = "FULL_AUTHENTICATED_USER";
    SessionAuthorityTypes["MINIMAL_AUTHENTICATED_USER"] = "MINIMAL_AUTHENTICATED_USER";
    SessionAuthorityTypes["USERNAME_PASSWORD"] = "USERNAME_PASSWORD";
    SessionAuthorityTypes["GUEST_WEB_RETURNS"] = "GUEST_WEB_RETURNS";
})(SessionAuthorityTypes || (exports.SessionAuthorityTypes = SessionAuthorityTypes = {}));
//# sourceMappingURL=SessionTypes.js.map